import { configureStore } from '@reduxjs/toolkit'
import authReducer from "./reducers/auth";
import configReducer from "./reducers/config";

export default configureStore({
  reducer: {
    auth          : authReducer
    ,config       : configReducer
  }
})